import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AcasaPage from "./pages/AcasaPage";
import DesprePage from "./pages/DesprePage";
import ProgramLucruPage from "./pages/ProgramLucruPage";
import DocumenteScolarePagePage from "./pages/Documente/DocumenteScolarePage";
import PublicatiiPage from "./pages/Documente/PublicatiiPage";
import InvProfesionalPage from "./pages/Educatie/InvProfesionalPage";
import ProiecteProgramePage from "./pages/ProiecteProgramePage";
import ResurseUmanePage from "./pages/ResurseUmanePage";
import ClasePage from "./pages/Educatie/ClasePage";
import OrarPage from "./pages/Educatie/OrarPage";
import OfertaEducationalaPage from "./pages/Educatie/OfertaEducationalaPage";
import TransferEleviPage from "./pages/Educatie/TransferEleviPage";
import PerformantaScolaraPage from "./pages/Educatie/PerformantaScolaraPage";
import OrganigramaPage from "./pages/Documente/OrganigramaPage";
import RevistaScoliiPage from "./pages/Documente/RevistaScoliiPage";
import HotarariCAPage from "./pages/Documente/HotarariCAPage";
import AnunturiPage from "./pages/AnunturPage";
import SmartLab from "./pages/proiecte/SmartLab";
import PNRAS from "./pages/proiecte/PNRAS";
import CercurileTematicePage from "./pages/proiecte/PNRAS/CercurileTematicePage";
import ActivitatiCercIstoriePage from "./pages/proiecte/PNRAS/ActivitatiCercIstoriePage";
import ActivitatiCercCreativiPage from "./pages/proiecte/PNRAS/ActivitatiCercCreativiPage";
import ActivitatiCercSportPage from "./pages/proiecte/PNRAS/ActivitatiCercSportPage";
import ActivitatiCercRoboticaPage from "./pages/proiecte/PNRAS/ActivitatiCercRoboticaPage";
import ActivitatiCercFizicaPage from "./pages/proiecte/PNRAS/ActivitatiCercFizicaPage";
import Erasmus from "./pages/proiecte/Erasmus";
import GreciaPage from "./pages/proiecte/Erasmus/GreciaPage";
import ItaliaPage from "./pages/proiecte/Erasmus/ItaliaPage";
import LetoniaPage from "./pages/proiecte/Erasmus/LetoniaPage";
import RomaniaPage from "./pages/proiecte/Erasmus/RomaniaPage";
import TurciaPage from "./pages/proiecte/Erasmus/TurciaPage";
import SaptMeseriilor from "./pages/proiecte/SaptMeseriilor";
import ConsiliulElevilorPage from "./pages/Educatie/ConsiliulElevilorPage";
import AutorizatiiPage from "./pages/Documente/AutorizatiiPage"
import DeclaratiiPage from "./pages/Documente/DeclaratiiPage"
import SurseFinanciarePage from "./pages/Documente/SurseFinanciarePage";
import InscrieriPregatitoarePage from "./pages/Educatie/InscrieriPregatitoarePage";
import InscrieriGradinitaPage from "./pages/Educatie/InscrieriGradinitaPage";
import TicheteSocialePage from "./pages/Educatie/TicheteSocialePage";
import EvaluareNationalaPage from "./pages/Educatie/EvaluareNationalaPage";
import ProceduriOperarionalePage from "./pages/Documente/ProceduriOperationalePage";
import DeciziiPage from "./pages/Documente/DeciziiPage"
import ActivitatiExtracurriculare from "./pages/programe/ActivitatiExtracurriculare";
import FormareProfesoriPage from "./pages/Documente/FormareProfesoriPage";
import MobilitatePage from "./pages/Documente/MobilitatePage";
import SSMPSIPage from "./pages/Documente/SSMPSIPage";
import OrgColectivEleviPage from "./pages/Educatie/OrgColectivEleviPage";
import SimulariPage from "./pages/Educatie/SimulariPage";
import RechiziteScolarePage from "./pages/Educatie/RechiziteScolarePage";
import BurseScolarePage from "./pages/Educatie/BurseScolarePage";

export default function App() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <div className="flex-grow">
        <Routes>
          <Route path="/" element={<AcasaPage />} />
          <Route path="/despre" element={<DesprePage />} />
          <Route path="/documenteScolare" element={<DocumenteScolarePagePage />} />
          <Route path="/publicatii" element={<PublicatiiPage />} />
          <Route path="/profesional" element={<InvProfesionalPage />} />
          <Route path="/proiecte&programe" element={<ProiecteProgramePage />} />
          <Route path="/proiecte/SmartLab" element={<SmartLab />} />
          <Route path="/proiecte/Erasmus+" element={<Erasmus />} />
          <Route path="/proiecte/PNRAS" element={<PNRAS />} />
          <Route
            path="/proiecte/PNRAS/cercurile-tematice"
            element={<CercurileTematicePage />}
          />
          <Route
            path="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-istorie"
            element={<ActivitatiCercIstoriePage />}
          />
          <Route
            path="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-creativi"
            element={<ActivitatiCercCreativiPage />}
          />
          <Route
            path="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-sport"
            element={<ActivitatiCercSportPage />}
          />
          <Route
            path="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-robotica"
            element={<ActivitatiCercRoboticaPage />}
          />
          <Route
            path="/proiecte/PNRAS/cercurile-tematice/activitati-cerc-fizica"
            element={<ActivitatiCercFizicaPage />}
          />
          <Route path="/proiecte/Erasmus+/Grecia" element={<GreciaPage />} />
          <Route path="/proiecte/Erasmus+/Italia" element={<ItaliaPage />} />
          <Route path="/proiecte/Erasmus+/Letonia" element={<LetoniaPage />} />
          <Route path="/proiecte/Erasmus+/Romania" element={<RomaniaPage />} />
          <Route path="/proiecte/Erasmus+/Turcia" element={<TurciaPage />} />
          <Route
            path="/proiecte/saptamana-meseriilor"
            element={<SaptMeseriilor />}
          />
          <Route path="/programe/activitati" element={<ActivitatiExtracurriculare />} />
          <Route path="/evaluare-nationala" element={<EvaluareNationalaPage />} />
          <Route path="/simulari" element={<SimulariPage />} />
          <Route path="/program-de-lucru" element={<ProgramLucruPage />} />
          <Route path="/clase" element={<ClasePage />} />
          <Route path="/orar" element={<OrarPage />} />
          <Route path="/inscrieri-gradinita" element={<InscrieriGradinitaPage />} />
          <Route path="/inscrieri-clasa-pregatitoare" element={<InscrieriPregatitoarePage />} />
          <Route path="/tichete-sociale" element={<TicheteSocialePage />} />
          <Route path="rechizite-scolare" element={<RechiziteScolarePage />} />
          <Route path="burse-scolare" element={<BurseScolarePage />} />
          <Route
            path="/oferta-educationala"
            element={<OfertaEducationalaPage />}
          />
          <Route path="/transfer-elevi" element={<TransferEleviPage />} />
          <Route
            path="/performanta-scolara"
            element={<PerformantaScolaraPage />}
          />
          <Route path="/organizarea-colectiv-elevi" element={<OrgColectivEleviPage />} />
          <Route path="/resurse-umane" element={<ResurseUmanePage />} />
          <Route path="/organigrama" element={<OrganigramaPage />} />
          <Route path="/revista-scolii" element={<RevistaScoliiPage />} />
          <Route path="/hotarariCA" element={<HotarariCAPage />} />
          <Route path="/proceduri-operationale" element={<ProceduriOperarionalePage />} />
          <Route path="/formare-profesori" element={<FormareProfesoriPage />} />
          <Route path="/mobilitate" element={<MobilitatePage />} />
          <Route path="/SSM_PSI" element={<SSMPSIPage />} />
          <Route path="/decizii" element={<DeciziiPage />} />
          <Route path="/anunturi" element={<AnunturiPage />} />
          <Route path="/consiliul-elevilor" element={<ConsiliulElevilorPage />} />
          <Route path="/autorizatii" element={<AutorizatiiPage />} />
          <Route path="/declaratii" element={<DeclaratiiPage />} />
          <Route path="/surse-financiare" element={<SurseFinanciarePage />} />
        </Routes>
      </div>

      <Footer />
    </div>
  );
}
